import type { RouteRecordRaw } from "vue-router"

import PlainLayout from "@/components/layout/PlainLayout.vue"
import GeneralErrorPage from "@/pages/error/GeneralErrorPage.vue"

export const ErrorRoutes: RouteRecordRaw[] = [
  {
    name: "errors",
    components: {
      layout: PlainLayout,
    },
    path: "/error",
    children: [
      {
        name: "error.general",
        path: "general",
        component: GeneralErrorPage,
      },
      {
        name: "error.unauthorized",
        path: "unauthorized",
        component: () => import("@/pages/error/UnauthorizedPage.vue"),
      },
      {
        name: "error.timeout",
        path: "timeout",
        component: () => import("@/pages/error/SessionTimeoutPage.vue"),
        props: (route) => ({
          finish: route.query.finish !== "false",
          redirectUrl: route.query.destination,
        }),
      },
    ],
    meta: {
      public: true,
      preventBack: true,
    },
  },
]
